import script from "./PayTypeCount.vue?vue&type=script&setup=true&lang=js"
export * from "./PayTypeCount.vue?vue&type=script&setup=true&lang=js"

import "./PayTypeCount.vue?vue&type=style&index=0&id=3d9b5f8a&scoped=true&lang=less"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d9b5f8a"]])

export default __exports__